import React from 'react'
import {Button} from 'react-daisyui'

interface SingleInvoiceProps {
  isLoading: boolean
  onDownloadAll: () => void
}

const SingleInvoice: React.FC<SingleInvoiceProps> = ({
  isLoading,
  onDownloadAll
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:gap-12 pt-4 w-full">
      <div className="flex-1">
        <h2 className="font-semibold text-lg mb-1">Download Invoice</h2>
        <p className="text-sm text-gray-700">Invoice will download as a pdf.</p>
      </div>
      <div className="flex-1 flex justify-start md:justify-end gap-4 mt-5 md:mt-0 mb-4">
        <div className="flex flex-col items-start md:items-end">
          <Button
            className="btn btn-secondary font-semibold w-fit px-8 py-2 min-w-[220px]"
            aria-label="Download All Invoices Button"
            onClick={onDownloadAll}
            disabled={isLoading}
          >
            download invoice
          </Button>
          {isLoading && (
            <div className="w-[220px] text-center text-[10px] text-gray-600 mt-1">
              Generating invoice...
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SingleInvoice
